import sponsor1 from "../../assets/img/sponsor1.png";
import sponsor2 from "../../assets/img/sponsor2.png";
import sponsor3 from "../../assets/img/sponsor3.png";
import awardLeft from "../../assets/img/Group 6439.png";
import awardRight from "../../assets/img/Group 6440.png";

export default function SponsorSection() {
  return (
    <section className="sponsor section">
      <h2 className="section__title section__title-gradient">Featured In</h2>

      <div className="sponsor__container container grid">
        <div className="sponsor__awardRow">
          <img src={awardLeft} className="award" alt="Award left" />

          <a
            href="https://apps.apple.com/us/app/topgun-aviation-academy/id6738648694"
            target="_blank"
            rel="noreferrer"
          >
            <img src={sponsor1} alt="Topgun on Uneed" className="sponsor__img" />
          </a>

          <img src={awardRight} className="award" alt="Award right" />
        </div>

       <div className="sponsor__awardRow">
          <img src={awardLeft} className="award" alt="Award left" />

          <a
            href="https://www.producthunt.com/products/topgun"
            target="_blank"
            rel="noreferrer"
          >
            <img src={sponsor2} alt="Topgun on Uneed" className="sponsor__img" />
          </a>

          <img src={awardRight} className="award" alt="Award right" />
        </div>
 <div className="sponsor__awardRow">
          <img src={awardLeft} className="award" alt="Award left" />

          <a
            href="https://www.uneed.best/tool/topgun"
            target="_blank"
            rel="noreferrer"
          >
            <img src={sponsor3} alt="Topgun on Uneed" className="sponsor__img" />
          </a>

          <img src={awardRight} className="award" alt="Award right" />
        </div>
        <div>
        <a href="https://fazier.com" target="_blank" rel="noreferrer">
          <img
            src="https://fazier.com/api/v1//public/badges/launch_badges.svg?badge_type=launched&theme=dark"
            width="120"
            alt="Fazier badge"
          />
        </a>
      </div>
      </div>
    </section>
  );
}
